import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/partners/page.tsx");
